import { Button, Modal } from "antd";
import styles from "./CustomModal.module.css";

const CustomModal = ({
  title,
  content,
  handleCancel,
  handleOk,
  showModal,
  isModalOpen,
  showHeader = true,
  showFooter = true,
  className
}) => {
  return (
    <Modal
      title={null}
      open={isModalOpen}
      footer={null}
      onCancel={handleCancel}
      centered
      className={`${styles.customModal} ${className}`}
    >
      {showHeader && (
        <div className={styles.header}>
          <h2>{title}</h2>
        </div>
      )}

      <div className={styles.body}>{content}</div>

      {showFooter && (
        <div className={styles.footer}>
          <Button onClick={handleCancel} className={styles.cancelBtn}>
            Cancel
          </Button>
          <Button type="primary" onClick={handleOk} className={styles.okBtn}>
            Confirm
          </Button>
        </div>
      )}
    </Modal>
  );
};

export default CustomModal;
